// Minimal IATA → [lat, lng] dictionary for the airports Flight 380 uses most.
// Used to draw great-circle route lines when AirLabs has no live position
// (e.g. flight is still scheduled or already landed).
const AIRPORT_COORDS = {
  // UK
  LHR: [51.4700, -0.4543], LGW: [51.1537, -0.1821], STN: [51.8860, 0.2389],
  LTN: [51.8747, -0.3683], LCY: [51.5053, 0.0553], MAN: [53.3537, -2.2750],
  BHX: [52.4539, -1.7480], EDI: [55.9500, -3.3725], GLA: [55.8719, -4.4331],
  NCL: [55.0375, -1.6917], LBA: [53.8659, -1.6608], BRS: [51.3827, -2.7191],
  EMA: [52.8311, -1.3281], LPL: [53.3336, -2.8497],
  // Pakistan
  ISB: [33.5616, 72.8253], KHI: [24.9065, 67.1610], LHE: [31.5217, 74.4036],
  MUX: [30.2032, 71.4191], PEW: [33.9939, 71.5145], FSD: [31.3650, 72.9947],
  SKZ: [27.7211, 68.7926], SDT: [25.7591, 63.2750],
  // KSA / Gulf
  JED: [21.6796, 39.1565], MED: [24.5534, 39.7051], RUH: [24.9576, 46.6988],
  DMM: [26.4712, 49.7980], AHB: [18.2403, 42.6566], TIF: [21.4834, 40.5435],
  DXB: [25.2532, 55.3657], DWC: [24.8967, 55.1614], AUH: [24.4427, 54.6511],
  SHJ: [25.3286, 55.5172], DOH: [25.2731, 51.6080], KWI: [29.2266, 47.9689],
  BAH: [26.2708, 50.6336], MCT: [23.5933, 58.2844],
  // Major hubs / connections
  IST: [41.2753, 28.7519], FRA: [50.0379, 8.5622], CDG: [49.0097, 2.5479],
  AMS: [52.3105, 4.7683], BRU: [50.9014, 4.4844], JFK: [40.6413, -73.7781],
  LAX: [33.9416, -118.4085], YYZ: [43.6777, -79.6248],
  // South Asia common connections
  DEL: [28.5562, 77.1000], BOM: [19.0896, 72.8656], BLR: [13.1986, 77.7066],
  COK: [10.1520, 76.4019], CCU: [22.6547, 88.4467], MAA: [12.9941, 80.1709],
  CMB: [7.1808, 79.8841], DAC: [23.8431, 90.4002], HYD: [17.2403, 78.4294],
  AMD: [23.0726, 72.6266], BKK: [13.6900, 100.7501], SIN: [1.3644, 103.9915],
  KUL: [2.7456, 101.7099], HKG: [22.3080, 113.9185], MNL: [14.5086, 121.0194],
  TAS: [41.2579, 69.2811], DYU: [38.5430, 68.8233], ALA: [43.3521, 77.0405],
};

export default AIRPORT_COORDS;
